"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MartianLumberCorp = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const Tags_1 = require("../Tags");
const Units_1 = require("../../Units");
const Size_1 = require("../render/Size");
class MartianLumberCorp extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.BUILDING, Tags_1.Tags.PLANT],
            name: CardName_1.CardName.MARTIAN_LUMBER_CORP,
            cost: 6,
            productionBox: Units_1.Units.of({ plants: 1 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.greeneries(2)),
            metadata: {
                cardNumber: 'X60',
                description: 'Requires that you have 2 greenery tiles. Increase your plant production 1 step.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('When playing a Building tag, plants may be used as 3 M€ each.', (eb) => {
                        eb.building().played.startEffect.plants(1).nbsp(Size_1.Size.TINY).equals().megacredits(3);
                    });
                    b.br.br;
                    b.production((pb) => pb.plants(1));
                }),
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        return undefined;
    }
}
exports.MartianLumberCorp = MartianLumberCorp;
//# sourceMappingURL=MartianLumberCorp.js.map